module.exports = {"370503001":"河口街道","370503002":"六合街道","370503100":"义和镇","370503101":"仙河镇","370503102":"孤岛镇","370503103":"新户镇","370503400":"河口经济开发区","370503401":"河口蓝色经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370503.json
// module id = 1508
// module chunks = 0